module.exports = __webpack_public_path__ + "img/xiezhen3.241699bd.png";